import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleArrowUp,faCircleArrowDown} from '@fortawesome/free-solid-svg-icons'
//import Selection from '../components/Selection'

function TableHeadRow({name, sortOrder, sortColumn, handleSort, value}) {
  return (
    <th onClick={() => handleSort(value)} value={value} style={{borderTopLeftRadius:'0.2rem',borderTopRightRadius:'0.2rem'}} >
       <a href='#ll' style={{color: sortColumn ? 'orange' : ''}}> {name} 
        <div>
        {sortColumn ? (value === '#') ? '' : (
            value && sortOrder ? (
            <span style={{marginRight:'0.1rem', marginLeft:'0.8rem'}}> 
                { <FontAwesomeIcon icon={faCircleArrowUp} />} 
            </span>
            ) : (
            <span style={{marginRight:'0rem', marginLeft:'0.8rem'}}> 
                { <FontAwesomeIcon icon={faCircleArrowDown} />}
            </span>
            )
            ) : ( 
                
                ''
            )
        }
        </div>
        </a>
    </th>
  )
}

export default TableHeadRow